namespace GeniuzPOS.RefundReasonReport {
    export namespace ReportRefundReasonByItemService {
        export const baseUrl = 'RefundReasonReport/ReportRefundReasonByItem';

        export declare function Create(request: Serenity.SaveRequest<ReportRefundReasonByItemRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<ReportRefundReasonByItemRow>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<ReportRefundReasonByItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ReportRefundReasonByItemRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "RefundReasonReport/ReportRefundReasonByItem/Create",
            Update = "RefundReasonReport/ReportRefundReasonByItem/Update",
            Delete = "RefundReasonReport/ReportRefundReasonByItem/Delete",
            Retrieve = "RefundReasonReport/ReportRefundReasonByItem/Retrieve",
            List = "RefundReasonReport/ReportRefundReasonByItem/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>ReportRefundReasonByItemService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
